import {Directive, HostListener} from "@angular/core";

@Directive({
    selector: '[stop-propagation]',
    standalone: false
})
export class StopPropagation {
  @HostListener('click', ['$event'])
  public onClick(event: any): void {
    event.stopPropagation();
  }
}